/**
 * Check if the current route is an authentication-related route
 * @param {string} pathname - The current pathname
 * @returns {boolean} True if the route is an auth route
 */
export function isAuthRoute(pathname) {
  const authRoutes = ['/forgot', '/login', '/mfa'];
  return authRoutes.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );
}

/**
 * Apply mobile-friendly dialog styling for authentication-related routes
 * Mutates the config object by adding 'login_dialog' class if on auth routes
 * @param {Object} config - Dialog configuration object
 * @returns {void}
 */
export function applyAuthRouteDialogClass(config) {
  const currentRoute = window.location.pathname;
  if (isAuthRoute(currentRoute) && !config.classes) {
    config.classes = ['login_dialog'];
  }
}
